import React, { useState } from 'react';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { storage, db } from '../../config/firebase';  // Your initialized firebase app exports

const UploadPaper = () => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const onFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && selectedFile.type === 'application/pdf') {
      setFile(selectedFile);
      setError('');
    } else {
      setError('Please select a valid PDF file.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setError('No file selected');
      return;
    }

    setUploading(true);
    setError('');
    try {
      // Create storage ref with a unique name
      const filename = `papers/edition_${new Date().toISOString().split('T')[0]}.pdf`;
      const storageRef = ref(storage, filename);

      // Upload the file using Firebase Storage SDK
      await uploadBytes(storageRef, file);

      // Get the download URL
      const downloadURL = await getDownloadURL(storageRef);

      // Save metadata in Firestore
      await addDoc(collection(db, 'papers'), {
        date: serverTimestamp(),
        filename,
        url: downloadURL,
        createdAt: new Date().toISOString()
      });

      setSuccess(true);
      setFile(null);
      setTimeout(() => setSuccess(false), 3000);
    } catch (err) {
      setError(err.message);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div>
      <h2>Upload Today's Paper (PDF)</h2>
      {success && <p style={{ color: 'green' }}>Upload successful!</p>}
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <form onSubmit={handleSubmit}>
        <input type="file" accept="application/pdf" onChange={onFileChange} />
        <button type="submit" disabled={uploading}>
          {uploading ? 'Uploading...' : 'Upload'}
        </button>
      </form>
    </div>
  );
};

export default UploadPaper;
